import { WitaConnector } from '@/services/repository/connector'
import { FormDataHandler } from '@/utils/helpers/FormDataHandler'
import { querySerializer } from '@/utils/helpers/URLs'

import { Repo } from './CallTechAttachment.d'

const ROOT_URL = '/entity/call-tech-attachment'

export const CallTechAttachment_Repository = {
  Search: async (params: Repo.CallTechAttachments.FindByCallId.Params) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<Repo.CallTechAttachments.FindByCallId.Response>(
      url,
    )
  },

  Create: async (params: Repo.CallTechAttachments.Create.Params) => {
    const formData = FormDataHandler(params)
    const url = ROOT_URL
    return await WitaConnector.post<Repo.CallTechAttachments.Create.Response>(
      url,
      formData,
    )
  },

  Delete: async ({ id }: Repo.CallTechAttachments.Delete.Params) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.delete<Repo.CallTechAttachments.Delete.Response>(
      url,
    )
  },
}
